import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import axios from "axios";

// CRITICAL FIX: Handle custom domain vs Emergent host URL mismatch
// When user visits pricepalcompare.com, REACT_APP_BACKEND_URL might point
// to legacy-safe.emergent.host. This causes cross-origin cookie failures.
// Fix: Rewrite absolute URLs to relative when on a custom domain.
(function setupApiUrlInterceptor() {
  const envBackendUrl = process.env.REACT_APP_BACKEND_URL || '';
  if (!envBackendUrl || typeof window === 'undefined') return;

  try {
    const backendHost = new URL(envBackendUrl).hostname;
    const currentHost = window.location.hostname;

    // If hosts don't match, we're on a custom domain or localhost — rewrite URLs to relative
    // Kubernetes ingress (prod) or setupProxy.js (dev) handles /api/* routing
    if (currentHost !== backendHost) {
      // Intercept axios requests
      axios.interceptors.request.use((config) => {
        if (config.url && config.url.startsWith(envBackendUrl)) {
          config.url = config.url.replace(envBackendUrl, '');
        }
        const httpsUrl = `https://${backendHost}`;
        const httpUrl = `http://${backendHost}`;
        if (config.url && config.url.startsWith(httpsUrl)) {
          config.url = config.url.replace(httpsUrl, '');
        }
        if (config.url && config.url.startsWith(httpUrl)) {
          config.url = config.url.replace(httpUrl, '');
        }
        return config;
      });

      // Intercept native fetch requests
      const originalFetch = window.fetch;
      window.fetch = function(url, options) {
        if (typeof url === 'string') {
          if (url.startsWith(envBackendUrl)) {
            url = url.replace(envBackendUrl, '');
          } else if (url.startsWith(`https://${backendHost}`)) {
            url = url.replace(`https://${backendHost}`, '');
          } else if (url.startsWith(`http://${backendHost}`)) {
            url = url.replace(`http://${backendHost}`, '');
          }
        }
        return originalFetch.call(this, url, options);
      };

      console.log(`[PricePAL] Custom domain detected (${currentHost}). API calls rewritten to relative URLs.`);
    }
  } catch (e) {
    // Silently continue
  }
})();

import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);

// Service worker DISABLED after v7 kill-switch (2026-07-01).
// Instead of registering the PWA SW, we proactively unregister any SW that
// may have been left behind on the user's browser AND wipe every cache.
// This ensures /admin, /api/* and other route navigation always reach the
// live server — the previous cache-first SW was serving stale content and
// blocking admin login for existing PWA users. When you want PWA support
// back later, restore the serviceWorkerRegistration.register(...) call and
// bump the SW version so browsers pick up the new file.
(async () => {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const r of regs) {
        try { await r.unregister(); } catch (e) { /* ignore */ }
      }
    }
    if ('caches' in window) {
      const keys = await caches.keys();
      for (const k of keys) {
        try { await caches.delete(k); } catch (e) { /* ignore */ }
      }
    }
  } catch (e) { /* ignore — best-effort cleanup */ }
})();
